import axios from 'axios'
import { config } from '../utils/Constants'

export const UsersService = {
    getUsers,
    getUserById,
    search,
    update,
    updatePrivacy,
    updatePassword,
    disable,
    newUsers,
    accountsByUserId,
    profilesByUserId
}

// -- Axios

const instance = axios.create({
    baseURL: config.url.API_BASE_URL
})

instance.interceptors.response.use(response => {
    return response;
}, function (error) {
    console.log(error) 
    return error.response;
    // if (error.response.status === 404 ) {
    //     return { status: error.response.status };
    // }else if(error.response.status === 500 || error.response.status === 0){ 
    //     return { status: error.response.status };
    // }else{
    //     return { status: error.response.status };
    // }
    //return Promise.reject(error.response);
});
// -- Helper functions
function bearerAuth(token) {
    return `Bearer ${token}`
}

function profilesByUserId(token,type){
    var data = {};
    data["type"] = type;
    return instance.get('/tsbadmin/api/users/profiles/', {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token)
        },
        params:data
    })
}

function accountsByUserId(token,type){
    var data = {};
    data["type"] = type;
    return instance.get('/tsbadmin/api/users/accounts/', {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token)
        },
        params:data
    })
}

function getUsers(token,filter,userid) {
    return instance.get('/tsbadmin/api/users/', {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token),
            'user-id': userid,
        },
        params:filter
    })
}

function getUserById(token,id,filter) {
   // token ="eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJMSWQzZnYyQU5kb2Y5QVRNSVR5azBhSnpXamtvWnctRGx0MHBuVFE4QnFvIn0.eyJleHAiOjE2NTY0MjYyNzYsImlhdCI6MTY1NjQyMjY3NiwianRpIjoiNjEzMDBiMjUtNjNiNi00Yzg1LWIyMGEtMzM0NmI4MzYyZDhmIiwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo4MDgwL2F1dGgvcmVhbG1zL1Rvc2hpYmFIdWIiLCJhdWQiOlsicmVhbG0tbWFuYWdlbWVudCIsInRvc2hpYmEtd2ViLWFwcCIsImFjY291bnQiXSwic3ViIjoiMmFmMzFiYzEtODVkZi00YjkxLWE5NTItYzJlMmE1OWI0ZTM1IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoic3ByaW5nLWdhdGV3YXktY2xpZW50Iiwic2Vzc2lvbl9zdGF0ZSI6ImJiZDU2OTdjLTNjOGQtNDkzMS1iNjExLWRiZTc2MWEzYzU5ZSIsImFjciI6IjEiLCJhbGxvd2VkLW9yaWdpbnMiOlsiKiJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiYWNjZXNzX3VzZXJzIiwib2ZmbGluZV9hY2Nlc3MiLCJhZG1pbiIsImFjY2Vzc19ncm91cHMiLCJ1bWFfYXV0aG9yaXphdGlvbiIsIm1hbmFnZW1lbnRfdXNlcnMiLCJkZWZhdWx0LXJvbGVzLXRvc2hpYmFodWIiLCJtYW5hZ2VtZW50X2dyb3VwcyJdfSwicmVzb3VyY2VfYWNjZXNzIjp7InJlYWxtLW1hbmFnZW1lbnQiOnsicm9sZXMiOlsidmlldy1pZGVudGl0eS1wcm92aWRlcnMiLCJ2aWV3LXJlYWxtIiwibWFuYWdlLWlkZW50aXR5LXByb3ZpZGVycyIsImltcGVyc29uYXRpb24iLCJyZWFsbS1hZG1pbiIsImNyZWF0ZS1jbGllbnQiLCJtYW5hZ2UtdXNlcnMiLCJxdWVyeS1yZWFsbXMiLCJ2aWV3LWF1dGhvcml6YXRpb24iLCJxdWVyeS1jbGllbnRzIiwicXVlcnktdXNlcnMiLCJtYW5hZ2UtZXZlbnRzIiwibWFuYWdlLXJlYWxtIiwidmlldy1ldmVudHMiLCJ2aWV3LXVzZXJzIiwidmlldy1jbGllbnRzIiwibWFuYWdlLWF1dGhvcml6YXRpb24iLCJtYW5hZ2UtY2xpZW50cyIsInF1ZXJ5LWdyb3VwcyJdfSwidG9zaGliYS13ZWItYXBwIjp7InJvbGVzIjpbImFkbWluIl19LCJzcHJpbmctZ2F0ZXdheS1jbGllbnQiOnsicm9sZXMiOlsidGVzdFJvbGVDbGllbnQiXX0sImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoicHJvZmlsZSBlbWFpbCIsInNpZCI6ImJiZDU2OTdjLTNjOGQtNDkzMS1iNjExLWRiZTc2MWEzYzU5ZSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwiR3JvdXBzIjpbIlByb2ZpbG8gYWRtaW4gVG9zaGliYSJdLCJuYW1lIjoiZ2lvdmFubmkgbGVsbGEiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJhZG1pbiIsImFjY291bnRzIjpbNSw2XSwiZ2l2ZW5fbmFtZSI6Imdpb3Zhbm5pIiwiZmFtaWx5X25hbWUiOiJsZWxsYSIsImVtYWlsIjoiZ2lvdmFubmkubGVsbGFAaW50ZXJ6ZW4uaXQifQ.SE2FeUsJcHyWWaniNYEwnLKDLXqFTbK68zlTB_jbneXp1KS_mlShxUjfUxE6i26x1sF-CQbGNMVgjtboqo2w87oJeT9iRzcKJ4V2kwP9TlzVWJweFJRcUSE3Jj2GZrCOA5_We-ytNDrxH-nFCTu4hSMZu9_6Fagy_7ysXYq5G-Se3GZSA2WwkNsPt-0TZEc5cMmDlfLic_vRG0AAyn0N1aOk503LPzxG1FyVK_R1om8vmtfjRvEZejNg73pFOHqsdMMZFzbjVxUypmB8IqYkl1vFInDLWDSplq2SouJG7Znn6ZZevw0XvGkmwCCD0B8oFJrDEMtkuC-bQ0SH1CnsNg"; 
    return instance.get('/tsbadmin/api/users/'+id, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token)
        },
        params:filter
    })
}

function update(token,id,data) {
    return instance.put('/tsbadmin/api/users/'+id, data, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token)
        }
    })
  }

  function newUsers(token,data) {
    return instance.post('/tsbadmin/api/users/', data, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token)
        }
    })
  }


  function disable(token,id) {
    return instance.put('/tsbadmin/api/disable/users/'+id,[], {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token)
        }
    })
  }



  function updatePrivacy(token,id,data) {
    return instance.put('/tsbadmin/api/users/privacy/'+id, data, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token)
        }
    })
  }

  function updatePassword(token,id,data) {
    return instance.put('/tsbadmin/api/users/password/'+id, data, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token)
        }
    })
    
  }

function search(token,searchQuery) {
    return instance.get('/tsbadmin/api/users/searchall/', {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(token)
        },params:searchQuery
    })
}
